{
  "days": {
    "friday": "星期五",
    "monday": "星期一",
    "saturday": "星期六",
    "sunday": "星期日",
    "thursday": "星期四",
    "tuesday": "星期二",
    "wednesday": "星期三"
  },
  "discover": {
    "explore": "探索地點"
  },
  "explore_list": {
    "description": "這個清單是從 {wikipage} 截取的。",
    "error": "載入清單時發生錯誤。",
    "title": "探索",
    "wikipage": "簡易室內標記 wiki 頁面"
  },
  "heatmap": {
    "hide": "隱藏熱力圖",
    "show": "顯示熱力圖"
  },
  "opening_hours": {
    "state": {
      "closed": "關閉",
      "open": "開啟"
    },
    "state_until_date": " 直到 {date} {state}",
    "tomorrow": "明天",
    "url": "檢視網站來查看營業時間"
  },
  "poi": {
    "aerialway": {
      "station": "纜車站"
    },
    "aeroway": {
      "gate": "登機門"
    },
    "amenity": {
      "arts_centre": "藝術中心",
      "atm": "自動櫃員機",
      "bank": "銀行",
      "bar": "酒吧",
      "bbq": "燒烤區",
      "bench": "長椅",
      "bicycle_parking": "自行車停車場",
      "bicycle_rental": "自行車租賃站",
      "biergarten": "露天啤酒花園",
      "bureau_de_change": "貨幣兌換處",
      "bus_station": "公車站",
      "cafe": "咖啡廳",
      "car_rental": "租車站",
      "cinema": "電影院",
      "clinic": "診所",
      "college": "進修教育機構",
      "community_centre": "社區中心",
      "courthouse": "地方法院",
      "dentist": "牙醫診所",
      "doctors": "私人診所",
      "embassy": "大使館",
      "fast_food": "速食店",
      "ferry_terminal": "渡輪碼頭",
      "fire_station": "消防隊",
      "food_court": "美食廣場",
      "fuel": "加油站",
      "grave_yard": "墓園",
      "hospital": "醫院",
      "ice_cream": "冰品店",
      "kindergarten": "幼兒園",
      "library": "圖書館",
      "marketplace": "市場",
      "motorcycle_parking": "機車停車場",
      "nightclub": "夜總會",
      "nursing_home": "療養院",
      "parking": "停車場",
      "pharmacy": "藥局/藥房",
      "photo_booth": "照相亭",
      "piano": "公共鋼琴",
      "place_of_worship": "參拜場所",
      "police": "派出所/分駐所",
      "post_box": "郵箱",
      "post_office": "郵局",
      "prison": "監獄",
      "pub": "酒館",
      "public_building": "公共建築",
      "recycling": "資源回收桶",
      "restaurant": "餐廳",
      "school": "小學/中學",
      "shelter": "涼亭",
      "swimming_pool": "游泳池",
      "taxi": "計程車招呼站",
      "telephone": "公用電話",
      "theatre": "戲劇院/劇場",
      "ticket_validator": "驗票機",
      "toilets": "廁所",
      "townhall": "市鎮廳",
      "university": "大學",
      "vending_machine": "自動販賣機",
      "veterinary": "獸醫診所/動物醫院",
      "waste_basket": "垃圾桶"
    },
    "barrier": {
      "bollard": "護柱",
      "border_control": "邊境管制",
      "cycle_barrier": "自行車柵欄",
      "gate": "閘門",
      "lift_gate": "遮斷機",
      "sally_port": "暗門",
      "stile": "梯磴",
      "toll_booth": "收費亭"
    },
    "craft": {
      "brewery": "釀造坊",
      "caterer": "餐飲服務商",
      "confectionery": "甜點店",
      "dressmaker": "裁縫",
      "electronics_repair": "電器維修行",
      "shoemaker": "製鞋匠",
      "tailor": "釀造坊"
    },
    "door": {
      "door": "門",
      "hinged": "門",
      "no": "門",
      "overhead": "門",
      "sliding": "推拉門",
      "yes": "門"
    },
    "emergency": {
      "defibrillator": "AED",
      "fire_extinguisher": "滅火器",
      "phone": "緊急電話"
    },
    "entrance": {
      "building": "主要出入口",
      "emergency": "緊急出口",
      "exit": "出口",
      "home": "主要出入口",
      "main": "主要出入口",
      "service": "服務出入口",
      "shop": "主要出入口",
      "staircase": "主要出入口",
      "yes": "主要出入口"
    },
    "exhibit": {
      "artwork": "藝術",
      "history": "歷史"
    },
    "highway": {
      "elevator": "電梯"
    },
    "landuse": {
      "basin": "儲水池",
      "brownfield": "棕地",
      "cemetery": "墓園",
      "reservoir": "水庫",
      "winter_sports": "冬季運動"
    },
    "leisure": {
      "dog_park": "寵物公園",
      "escape_game": "密室脫逃",
      "garden": "花園",
      "golf_course": "高爾夫球場",
      "hackerspace": "駭客空間",
      "ice_rink": "溜冰場",
      "marina": "碼頭",
      "miniature_golf": "迷你高爾夫",
      "park": "公園",
      "pitch": "球場",
      "playground": "遊樂場",
      "sports_centre": "運動中心",
      "stadium": "體育場",
      "swimming_area": "游泳池區域",
      "swimming_pool": "游泳池",
      "water_park": "水上遊樂園"
    },
    "office": {
      "government": "政府機構"
    },
    "railway": {
      "halt": "招呼站",
      "station": "車站",
      "subway_entrance": "捷運出入口",
      "train_station_entrance": "火車站出入口",
      "tram_stop": "街車站"
    },
    "shop": {
      "accessories": "配件店",
      "alcohol": "酒類賣店",
      "antiques": "古董店",
      "art": "美術店",
      "bag": "袋子店",
      "bakery": "烘培坊",
      "beauty": "美容店",
      "bed": "寢具店",
      "beverages": "飲料批發商",
      "bicycle": "自行車行",
      "books": "書店",
      "boutique": "精品店",
      "butcher": "肉販",
      "camera": "攝影店",
      "car": "汽車行",
      "car_parts": "汽車零件店",
      "car_repair": "汽車修護",
      "carpet": "地毯店",
      "charity": "慈善事業",
      "cheese": "起司店",
      "chemist": "美妝店",
      "chocolate": "巧克力店",
      "clothes": "衣飾店",
      "coffee": "咖啡店",
      "computer": "電腦店",
      "confectionery": "甜點店",
      "convenience": "便利商店",
      "copyshop": "影印店",
      "cosmetics": "化妝品店",
      "deli": "熟食店",
      "delicatessen": "熟食",
      "department_store": "百貨公司",
      "doityourself": "DIY店",
      "dry_cleaning": "乾洗店",
      "electronics": "電器店",
      "erotic": "情趣用品店",
      "fabric": "紡織品店",
      "fashion_accessories": "流行配件店",
      "florist": "花店",
      "frame": "表框店",
      "frozen_food": "冷凍食品",
      "furniture": "家具店",
      "garden_centre": "花園中心",
      "general": "店家",
      "gift": "禮品店",
      "greengrocer": "蔬果店",
      "hairdresser": "理髮店",
      "hardware": "硬體店",
      "hearing_aids": "助聽器",
      "hifi": "音響店",
      "houseware": "家居用品店",
      "ice_cream": "冰品店",
      "interior_decoration": "室內設計",
      "jewelry": "珠寶店",
      "kiosk": "售貨亭",
      "kitchen": "廚房用品店",
      "lamps": "燈具店",
      "laundry": "洗衣店",
      "leather": "皮革店",
      "locksmith": "鎖店",
      "mall": "購物中心",
      "massage": "按摩店",
      "mobile_phone": "手機店",
      "motorcycle": "機車店",
      "music": "音樂店",
      "musical_instrument": "樂器行",
      "newsagent": "報刊亭",
      "optician": "眼鏡店",
      "outdoor": "戶外用品店",
      "pastry": "糕點店",
      "perfume": "香水店",
      "perfumery": "香料店",
      "pet": "寵物店/寵物用品店",
      "photo": "照相店",
      "seafood": "海鮮店",
      "second_hand": "二手用品店",
      "shoes": "鞋店",
      "sports": "體育用品店",
      "stationery": "文具店",
      "supermarket": "超市",
      "tailor": "釀造坊",
      "tattoo": "刺青",
      "tea": "茶店",
      "ticket": "售票處",
      "tobacco": "菸品店",
      "toys": "玩具店",
      "travel_agency": "旅行社",
      "variety_store": "雜貨店",
      "video": "影音店",
      "video_games": "電玩店",
      "watches": "鐘錶店",
      "weapons": "武器店",
      "wholesale": "大賣場",
      "wine": "葡萄酒店/水果酒店"
    },
    "sport": {
      "american_football": "美式足球場",
      "archery": "射箭場",
      "athletics": "田徑場",
      "australian_football": "澳洲足球",
      "badminton": "羽球場",
      "baseball": "棒球場",
      "basketball": "籃球場",
      "beachvolleyball": "沙灘排球",
      "billiards": "撞球",
      "bmx": "BMX",
      "boules": "滾球",
      "bowls": "保齡球",
      "boxing": "拳擊",
      "canadian_football": "加拿大足球",
      "canoe": "獨木舟",
      "chess": "西洋棋",
      "climbing": "攀爬",
      "climbing_adventure": "攀爬挑戰",
      "cricket": "板球",
      "cricket_nets": "板球網",
      "croquet": "槌球",
      "curling": "冰壺",
      "cycling": "單車",
      "disc_golf": "飛盤高爾夫",
      "diving": "潛水",
      "dog_racing": "賽狗",
      "equestrian": "馬術",
      "fatsal": "室內五人制足球",
      "field_hockey": "草地曲棍球",
      "free_flying": "自由落體",
      "gaelic_games": "蓋爾式運動",
      "golf": "高爾夫",
      "gymnastics": "體操",
      "handball": "手球",
      "hockey": "曲棍球",
      "horse_racing": "賽馬",
      "horseshoes": "擲馬蹄鐵",
      "ice_hockey": "冰上曲棍球",
      "ice_stock": "冰上滑盤",
      "judo": "柔道",
      "karting": "卡丁車",
      "korfball": "合球",
      "long_jump": "跳遠",
      "model_aerodrome": "模型飛機",
      "motocross": "機車越野賽",
      "motor": "機車賽",
      "multi": "多項運動",
      "netball": "籃網球",
      "orienteering": "定向越野",
      "paddle_tennis": "板網球",
      "paintball": "漆彈",
      "paragliding": "飛行傘",
      "pelota": "巴斯克回力球",
      "racquet": "球拍",
      "rc_car": "遙控車",
      "rowing": "划船",
      "rugby": "橄欖球",
      "rugby_league": "聯盟式橄欖球",
      "rugby_union": "聯合式橄欖球",
      "running": "跑步",
      "sailing": "帆船",
      "scuba_diving": "水肺潛水",
      "shooting": "射擊",
      "shooting_range": "射擊場",
      "skateboard": "滑板",
      "skating": "溜冰",
      "skiing": "滑雪",
      "soccer": "足球",
      "surfing": "衝浪",
      "swimming": "游泳",
      "table_soccer": "桌上足球",
      "table_tennis": "桌球",
      "team_handball": "團隊手球",
      "tennis": "網球",
      "toboggan": "雪橇",
      "volleyball": "排球",
      "water_ski": "滑水",
      "yoga": "瑜伽"
    },
    "tourism": {
      "alpine_hut": "山間小屋",
      "aquarium": "水族館",
      "artwork": "公共藝術",
      "attraction": "景點",
      "bed_and_breakfast": "民宿",
      "camp_site": "露營場",
      "caravan_site": "旅行拖車停車場",
      "chalet": "小木屋",
      "gallery": "藝廏",
      "guest_house": "招待所",
      "hostel": "青年旅館",
      "hotel": "旅館",
      "information": "資訊",
      "motel": "汽車旅館",
      "museum": "博物館",
      "picnic_site": "野餐區",
      "theme_park": "主題樂園",
      "viewpoint": "觀景點",
      "zoo": "動物園"
    }
  },
  "search": "搜尋",
  "sidebar": {
    "about": {
      "created_by": "由François de Metz建立",
      "title": "關於"
    },
    "api": {
      "embed": {
        "cta": "閱讀說明文件",
        "subtitle": "透過遠端API顯示互動式檢視器、預覽檔案、……。",
        "title": "嵌入Indoor="
      },
      "indoorequal": {
        "cta": "註冊",
        "subtitle": "要開始的話，請在 indoorequal.com 免費註冊帳號。",
        "title": "顯示Indoor=向量圖磚"
      },
      "schema": {
        "cta": "閱讀",
        "subtitle": "探索的向量圖撌的技術架構來將圖磚整合入任何 app。",
        "title": "閱讀規格"
      },
      "subtitle": "將Indoor=整合到應用程式中",
      "title": "開發者"
    },
    "collapse": "摺疊",
    "description": "indoor= 從 {0} 顯示室內資料，而且以 GeoJSON、OSM 與 IMDF 檔案預覽。",
    "explore": {
      "subtitle": "顯示室內地點",
      "title": "探索"
    },
    "last_update": "資料更新於{0}。{1}。",
    "status": "狀態",
    "learn": {
      "subtitle": "在開放街圖繪製室內區域",
      "title": "學習"
    },
    "news": {
      "subtitle": "Indoor=的最新消息",
      "title": "最新消息"
    },
    "preview": {
      "title": "預覽算繪",
      "subtitle": "在上傳室內畫地圖前預覽"
    },
    "taginfo": {
      "title": "Taginfo indoor=",
      "subtitle": "致力於室內圖徵的站臺"
    },
    "osm": "開放街圖"
  },
  "preview": {
    "close": "關閉預覽",
    "description": "選擇您室內畫地圖的算繪，選取或是拖拉符合簡單室內標籤架構的 GeoJSON 檔案或是 osm 檔案。",
    "download": "下載預覽檔案",
    "error": "顯示預覽發生錯誤：{msg}。",
    "error_bad_file": "無法解析檔案",
    "error_no_level": "沒有偵測到室內地圖圖徵",
    "file": "GeoJSON、OSM 或是 IMDB (壓縮) 檔案",
    "how": {
      "use_josm_plugin": "最容易使用預覽功能的方式是使用 indoor= JOSM 外掛。",
      "content1": "開啟 JOSM 之後來編輯室內區域",
      "content2": "點一下「檔案」->「儲存為…」，接著儲存為 GeoJSON 或是 osm 檔。",
      "content3": "選擇表單下方的檔案",
      "title": "操作說明"
    },
    "imdf": "預覽也同時支援 IMDB 檔案。",
    "no_data_uploaded": "不會遠端上傳檔案。\n所有事情發生在您的電腦上。",
    "title": "預覽算繪",
    "url": {
      "no": "否",
      "text": "您是否希望從{0}載入預覽檔案？",
      "title": "載入外部預覽",
      "yes": "是"
    }
  },
  "toolbar": {
    "edit": "編輯開放街圖",
    "menu": "選單",
    "view": "檢視地圖",
    "zoom_to_edit": "放大以編輯"
  },
  "wheelchair": {
    "limited": "有限的無障礙設施",
    "no": "沒有無障礙設施",
    "yes": "有無障礙設施"
  },
  "zoom": "放大來檢視室內圖資"
}
